import styled from 'styled-components'
import {font} from '~/src/config/theme'
import {APP_NAV_HEIGHT} from '~/src/components/ui/nav-menu-bar/navMetrics'

const Admin = {
  Container: styled.div`
    min-height: calc(100vh - 60px);
    margin-top: ${APP_NAV_HEIGHT};
    margin-bottom: 90px;
  `,
  Main: styled.div<{isCompact?: boolean}>`
    display: flex;
    min-width: 100%;
    justify-content: center;
    flex-direction: column;
    transition: all 400ms ease;
  `,
  Title: styled.h4`
    font-size: ${font.sizes.h4};
    font-weight: 400;
    line-height: 33px;
  `,
}

export default Admin
